<div class="lcl-quote-search-warning-routes" [ngClass]="{ 'lcl-quote-search-warning-routes-external': isExternal }">
  <div class="lcl-quote-search-warning-routes-header">
    <h3 class="lcl-quote-search-warning-routes-header-text">{{ (isWithForm ? "NO_ACTIVE_ROUTE_FOUND" : "WE_ARE_SORRY") | translate }}</h3>

    <span class="lcl-quote-search-warning-routes-header-close" (click)="close.emit()">
      <img class="mr-1" src="assets/icons/icon_close_gray_sm.svg" />
      <span>{{ "BUTTON.CLOSE" | translate }}</span>
    </span>
  </div>

  <div class="lcl-quote-search-warning-routes-body">
    <div class="lcl-quote-search-warning-routes-body-icon" *ngIf="!isWithForm">
      <img src="assets/icons/icon_routes.svg" />
    </div>

    <div class="lcl-quote-search-warning-routes-body-header">{{ "NO_ROUTES_FOUND_ATM" | translate }}</div>
    <div class="lcl-quote-search-warning-routes-body-hint">
      {{ (isWithForm ? "TRY_SELECTING_DIFFERENT_PORTS_FULL" : "TRY_SELECTING_DIFFERENT_PORTS") | translate }}
    </div>

    <div class="lcl-quote-search-warning-routes-body-form-element" *ngIf="isWithForm">
      <div class="row" *ngIf="isWithEmailAndName" [ngClass]="{ 'lcl-quote-search-warning-routes-body-form-element-pwd': isShowUserExists }">
        <div class="col-12" *ngIf="isShowUserExists">
          <span class="lcl-quote-search-warning-routes-body-form-element-hint">
            {{ "EXTERNAL_QUOTE_USER_EXISTS_NOTIFICATION" | translate }}
          </span>
        </div>

        <div class="col-12 col-xl-6">
          <app-control-wrapper [control]="emailFc" [errors]="errors">
            <label class="lcl-quote-search-warning-routes-body-form-element-label" for="email" control-label>
              {{ "FORM_LABEL.EMAIL_SHORT" | translate }}
            </label>
            <input
              control-wrapper
              type="text"
              id="email"
              name="email"
              class="form-control"
              [formControl]="emailFc"
              [placeholder]="'user@domain.com'"
              [mask]="'F*'"
              [dropSpecialCharacters]="false"
              [patterns]="CUSTOM_MASK"
              [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
            />
          </app-control-wrapper>
        </div>

        <div class="col-12 col-xl-6" *ngIf="!isShowUserExists">
          <app-control-wrapper [control]="nameFc" [errors]="errors">
            <label class="lcl-quote-search-warning-routes-body-form-element-label" for="name" control-label>
              {{ "LABELS.NAME" | translate }}
            </label>
            <input
              control-wrapper
              type="text"
              id="name"
              name="name"
              class="form-control"
              [formControl]="nameFc"
              [placeholder]="'YOUR_NAME' | translate"
              [mask]="'N{50}'"
              [dropSpecialCharacters]="true"
              [patterns]="CUSTOM_MASK"
              [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH'"
            />
          </app-control-wrapper>
        </div>

        <div class="col-12 col-xl-6" *ngIf="isShowUserExists">
          <app-control-wrapper [control]="nameFc" [errors]="errors">
            <label class="lcl-quote-search-warning-routes-body-form-element-label" for="password" control-label>
              {{ "LABELS.PASSWORD" | translate }}
            </label>
            <input
              control-wrapper
              type="password"
              id="password"
              name="password"
              class="form-control"
              [formControl]="passwordFc"
              [placeholder]="'LABELS.PASSWORD' | translate"
              [dropSpecialCharacters]="false"
              [patterns]="CUSTOM_MASK"
              [mask]="'F*'"
              [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
            />
          </app-control-wrapper>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <app-control-wrapper [control]="customerNotesFc">
            <label class="lcl-quote-search-warning-routes-body-form-element-label" for="customerNotes" control-label>
              {{ "SPECIAL_NOTES" | translate }}
            </label>
            <textarea
              control-wrapper
              type="text"
              class="form-control lcl-quote-search-warning-routes-body-form-element-input"
              id="customerNotes"
              name="customerNotes"
              [rows]="isMobile ? 4 : 2"
              [formControl]="customerNotesFc"
              [placeholder]="'SPECIAL_NOTES_PLACEHOLDER' | translate"
              [mask]="'Q*'"
              [patterns]="CUSTOM_MASK"
              [dropSpecialCharacters]="false"
              [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
            ></textarea>
          </app-control-wrapper>
        </div>
      </div>

      <button type="button" class="btn lcl-quote-search-warning-routes-body-btn" [disabled]="isButtonDisabled" (click)="notesSubmit.emit()">
        {{ "FIND_SPECIAL_OFFER" | translate }}

        <img src="/assets/icons/icon_arrow_right_white.svg" class="ml-2" />
      </button>
    </div>
  </div>
</div>
